// QA (ppe) environment — redeploy trigger only, no functional change (2026-06-20).
export const environment = {
  production: false,
  localDev: false,
  showAdminDebugBanner: false,
  allowAdminUrlFlags: false,
  //apiUrl: 'https://67exvp523q2icsifnfxrtef2q40gqddg.lambda-url.me-south-1.on.aws',
  apiUrl: 'https://prod-qa-chatbot-ecs.gfh.com',
  environmentName: 'ppe',
  deepgramWSURL: 'wss://gfh-dev-deepgram.aicg.com/v1/listen',
  deepgramWSURL_orig: 'wss://api.deepgram.com/v1/listen',
  //deepgramAgentWSURL: 'wss://deepgram-qa.gfh.com/v1/agent',
  deepgramAgentWSURL: 'wss://agent.deepgram.com/agent',
  openAiRealitimeAgentWSURL: 'wss://api.openai.com/v1/realtime',
  conversationMode : 'azure', // values: azure / saas — match upgrade/realtime + production
  azureOpenAiRealitimeAgentWSURL: 'https://dhari-m9sfipkd-eastus2.cognitiveservices.azure.com/openai/v1/realtime',
  openAIRealtimeModel: 'gpt-realtime-1.5',
  azureOpenAIRealtimeModel: 'gpt-realtime-1.5',
  // Deepgram API Key - Set via CI/CD environment variable substitution
  // DO NOT commit actual API keys to source control
  // deepgramApiKey: '${DEEPGRAM_API_KEY}'

  
};
